import React from "react";

const Badge = ({ icon, text, textColor, bgColor }) => {
  return (
    <div className={`rounded-2xl flex gap-1 items-center justify-center px-2 py-1 ${bgColor}`}>
      {
        icon &&
        icon
      }
      <p className={`text-xs font-semibold ${textColor}`}>{text}</p>
    </div>
  )
}

export default Badge;
